(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elite-sticky-product-action"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('elite-purchase-help')) {
    customElements.define('elite-purchase-help', class extends HTMLElement {
      connectedCallback() {
        this.info = document.querySelector(`product-info[data-product-id="${this.dataset.productId}"]`);
        if (!this.info) return;
        let v;
        try { v = JSON.parse(this.info.querySelector('[data-selected-variant]')?.textContent || 'null'); } catch { v = null; }
        const direct = Boolean(v?.id) && new URLSearchParams(location.search).get('variant') === String(v.id);
        this.confirmed = new Set();
        if (direct) this.groups().forEach((g) => this.confirmed.add(this.name(g)));
        const o = { signal: (this.abort = new AbortController()).signal };
        this.schedule = () => { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(() => this.sync()); };
        // Stop Dawn's media gallery jumping the page to the variant image after an option pick
        if (!window.__eliteScrollGuard) {
          window.__eliteScrollGuard = true;
          const orig = window.scrollTo.bind(window);
          window.scrollTo = function (a, b) {
            if (Date.now() < (window.__eliteHoldScroll || 0)) return;
            return orig(a, b);
          };
        }
        const hold = (e) => {
          if (e.target.closest && e.target.closest('variant-selects')) window.__eliteHoldScroll = Date.now() + 3000;
        };
        this.info.addEventListener('pointerdown', hold, { ...o, capture: true });
        this.info.addEventListener('change', hold, { ...o, capture: true });
        const confirm = (e) => {
          const g = this.groups().find((g) => g.contains(e.target));
          if (g && (e.type === 'change' || e.target.closest('input, label'))) this.confirmed.add(this.name(g));
          this.schedule();
        };
        this.info.addEventListener('click', (e) => {
          confirm(e);
          if (e.target.closest('[type="submit"]') && this.pending()) { e.preventDefault(); e.stopImmediatePropagation(); this.focus(); }
        }, { ...o, capture: true });
        this.info.addEventListener('change', confirm, { ...o, capture: true });
        this.info.addEventListener('submit', (e) => {
          if (e.target.matches('form[action*="/cart/add"]') && this.pending()) { e.preventDefault(); e.stopImmediatePropagation(); this.focus(); }
        }, { ...o, capture: true });
        (this.observer = new MutationObserver(this.schedule)).observe(this.info, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'checked'] });
        this.sync();
      }
      main() { return this.info.querySelector('product-form form[action*="/cart/add"] [type="submit"]'); }
      name(g) { return (g.querySelector('legend, .form__label')?.childNodes[0]?.textContent || '').replace(':', '').trim(); }
      groups() {
        return [...this.info.querySelectorAll('variant-selects .product-form__input')]
          .filter((g) => g.querySelectorAll('input[type="radio"], option').length > 1);
      }
      pending() { return this.groups().find((g) => !this.confirmed.has(this.name(g))); }
      focus() {
        const g = this.pending(); if (!g) return;
        g.scrollIntoView({ block: 'center', behavior: 'smooth' });
        g.querySelector('select, input')?.focus({ preventScroll: true });
      }
      sync() {
        const btn = this.main(); if (!btn) return;
        const g = this.pending();
        const label = btn.querySelector('span:not(.loading__spinner)');
        this.info.toggleAttribute('data-elite-size-required', Boolean(g));
        let prompt = this.info.querySelector('[data-elite-size-prompt]');
        if (g) {
          const text = 'Select a ' + (this.name(g).toLowerCase() || 'size');
          g.querySelectorAll('input[type="radio"]:checked').forEach((i) => { i.checked = false; });
          const sel = g.querySelector('[data-selected-value]'); if (sel && g.querySelector('input')) sel.textContent = '';
          if (!btn.disabled || btn.dataset.eliteLocked) {
            btn.dataset.eliteLocked = '1'; btn.disabled = true;
            if (label && label.textContent.trim() !== text) label.textContent = text;
          }
          if (!prompt) {
            prompt = document.createElement('p'); prompt.dataset.eliteSizePrompt = ''; prompt.className = 'elite-size-prompt';
            prompt.setAttribute('role', 'status'); g.before(prompt);
          }
          if (prompt.textContent !== text) prompt.textContent = text;
        } else {
          prompt?.remove();
          if (btn.dataset.eliteLocked) {
            delete btn.dataset.eliteLocked;
            let v;
            try { v = JSON.parse(this.info.querySelector('variant-selects [data-selected-variant]')?.textContent || 'null'); } catch { v = null; }
            if (v?.available) { btn.disabled = false; if (label) label.textContent = window.variantStrings?.addToCart || 'Add to cart'; }
            else if (label) label.textContent = window.variantStrings?.soldOut || 'Sold out';
          }
        }
      }
      disconnectedCallback() {
        this.abort?.abort(); this.observer?.disconnect(); cancelAnimationFrame(this.frame);
        this.info?.removeAttribute('data-elite-size-required');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
